// 주민등록번호 뒷자리 첫 글자 판정표 //
// 1·2 내국인 1900년대 / 3·4 내국인 2000년대 / 5·6 외국인 1900년대 / 7·8 외국인 2000년대 //
const CENTURY = {
  '1': '19',
  '2': '19',
  '3': '20',
  '4': '20',
  '5': '19',
  '6': '19',
  '7': '20',
  '8': '20'
};

const GENDER = {
  '1': 'male',
  '2': 'female',
  '3': 'male',
  '4': 'female',
  '5': 'male',
  '6': 'female',
  '7': 'male',
  '8': 'female'
};

// 뒷자리 첫 글자와 YYMMDD로 8자리 생년월일 계산 ( 판정 불가시 빈 문자열 ) //
export function toBirthDay(digit, yymmdd) {
  const century = CENTURY[digit];

  return century ? century + yymmdd : '';
}

// 뒷자리 첫 글자로 성별 계산 ( 판정 불가시 빈 문자열 ) //
export function toGender(digit) {
  return GENDER[digit] || '';
}

// 주민번호 원문(YYMMDD-N******)에서 뒷자리 첫 글자 추출 //
export function digitOf(ssn) {
  return (ssn && ssn.length > 7) ? ssn[7] : '';
}
